import styled from "styled-components";

const DeleteLink = styled.div`
  font-weight: 600;
  cursor: pointer;
  color: #ff2445;

  &:hover {
    text-decoration: underline;
  }
`;

export default DeleteLink;